import request from '../utils/request';

const API_URL = process.env.REACT_APP_API_URL;

const buildParams = ({ page = 1, pageSize = 5, ...filters } = {}) => {
  const params = { page, page_size: pageSize };
  for (const [key, value] of Object.entries(filters)) {
    if (value) params[key] = value;
  }
  return params;
};

export const fetchPendingIncomes = (opts = {}) => {
  return request('/api/monitor/pending-incomes', { params: buildParams(opts) });
};

export const fetchStalledIncomes = (opts = {}) => {
  return request('/api/monitor/stalled-incomes', { params: buildParams(opts) });
};

export const fetchPendingBatchSweeps = (opts = {}) => {
  return request('/api/monitor/pending-batch-sweeps', { params: buildParams(opts) });
};

export const fetchStalledBatchSweeps = (opts = {}) => {
  return request('/api/monitor/stalled-batch-sweeps', { params: buildParams(opts) });
};

export const fetchPendingTransfers = (opts = {}) => {
  return request('/api/monitor/pending-transfers', { params: buildParams(opts) });
};

export const fetchUtxoBalances = (opts = {}) => {
  return request('/api/monitor/total-utxo-balances', { params: buildParams(opts) });
};

export const fetchTransferWalletBalances = (opts = {}) => {
  return request('/api/monitor/transfer-wallet-balances', { params: buildParams(opts) });
};

export const fetchFilterOptions = () => {
  return request('/api/monitor/filter-options');
};
